import pagesReducer from './pages'
import calendarReducer from './calendar'

const combinedReducer = (state, action) => ({
	...pagesReducer(state, action),
	...calendarReducer(state, action),
})

export default combinedReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js